export default __webpack_public_path__ + "static/media/community-image-dao.8c2b23b6.png";